import { FC, useEffect, useRef } from 'react'

import Collapsable from '../Collapsable'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type GeneratingSectionProps = {
  title?: string
  subtitle?: string
  generatingMessage?: string
}

const GeneratingSection: FC<GeneratingSectionProps> = ({
  title,
  subtitle,
  generatingMessage,
}) => {
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView()
    }
  }, [])
  return (
    <Collapsable isCollapsable={ECollapsable.NONE} isOpenOnInit>
      <SC.Inner>
        <SC.ScrollInto ref={contentRef} />
        {title && <SC.Title>{title}</SC.Title>}
        {subtitle && <SC.SubTitle>{subtitle}</SC.SubTitle>}
        <SC.AnimationContainer>
          <SC.GenerationIcon className="rondelle" icon="rondelle" />
          <SC.GenerationIcon className="bowling" icon="bowling" />
          <SC.GenerationIcon className="baseball" icon="baseball" />
        </SC.AnimationContainer>
        {generatingMessage && (
          <SC.GeneratingMessage>{generatingMessage}</SC.GeneratingMessage>
        )}
      </SC.Inner>
    </Collapsable>
  )
}

export default GeneratingSection
